import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import RouterConstants from "../../constants/RouterConstants";
import { useAppStore } from "../../hooks/useStores";
import TabsLayout, { ITabLayout } from "../../layout/TabsLayout/TabsLayout";
import { OrgFeatures } from "../../models/billing";
import styles from "./AdsGeneration.module.scss";

const AdsGeneration = () => {
	const { t } = useTranslation("translation", { keyPrefix: "adsGeneration" });
	const { authStore } = useAppStore();
	let subTabs: ITabLayout[] = [
		{ name: t("overview.tab"), link: RouterConstants.ADS_GENERATION.OVERVIEW.path },
		{ name: t("api.tab"), link: RouterConstants.ADS_GENERATION.API.path },
		{ name: t("brandsTemplates.tab"), link: RouterConstants.ADS_GENERATION.BRANDS_TEMPLATES.path },
		// { name: t("iframe.tab"), link: RouterConstants.ADS_GENERATION.IFRAME.path },
		{ name: t("demo.tab"), link: RouterConstants.ADS_GENERATION.DEMO.path },
	];

	if (!authStore.isFeatureEnabled(OrgFeatures.CAMPAIGN)) {
		subTabs = subTabs.filter((tab) => tab.name !== t("brandsTemplates.tab"));
	}

	return (
		<TabsLayout contentClassName={styles.content} title={t("header")} subTabs={subTabs}>
			<Outlet />
		</TabsLayout>
	);
};

export default observer(AdsGeneration);
